module.exports = __webpack_public_path__ + "img/bgp01.74d4fb4f.jpg";